<app-system-dropdown-avatar
  [email]="(user$ | async) ?? ''"
  [name]="(user$ | async) ?? ''"
  [items]="items"
  [imgAvatar]="(imageAvatar$ | async) ?? ''"
  idDropdown="dropdownAvatarLanding"
></app-system-dropdown-avatar>
